// extracted by mini-css-extract-plugin
export var alignCenter = "_9t-d";
export var bannerShown = "_9t-6";
export var buttonContent = "_9t-0";
export var cardList = "_9t-1";
export var centerContent = "_9t-2";
export var chevron = "_9t-3";
export var closePanelButton = "_9t-k";
export var conversationContextContainer = "_9t-l";
export var conversationDetailContainer = "_9t-4";
export var detailWrapper = "_9t-7";
export var dropdownButton = "_9t-e";
export var dropdownTitle = "_9t-9";
export var fullHeight = "_9t-5";
export var hidden = "_9t-a";
export var icon = "_9t-b";
export var mergeSuggestionWrapper = "_9t-m";
export var panel = "_9t-i";
export var portalButtonsWrapper = "_9t-c";
export var right = "_9t-j";
export var tableSummaryContainer = "_9t-8";
export var tableSummaryHeader = "_9t-g";
export var threeDotsButton = "_9t-f";
export var wide = "_9t-h";